const GTM_BOOTSTRAP_SCRIPT_ID = 'google-tag-manager-bootstrap';

export const injectGoogleTagManagerScript = (googleTagManagerId: string | null | undefined): void => {
    if (!googleTagManagerId || document.getElementById(GTM_BOOTSTRAP_SCRIPT_ID)) return;

    const firstScript = document.getElementsByTagName('script')[0];
    const scriptToAdd = document.createElement('script');

    scriptToAdd.id = GTM_BOOTSTRAP_SCRIPT_ID;
    scriptToAdd.async = true;
    scriptToAdd.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`;

    if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(scriptToAdd, firstScript);
        return;
    }

    document.head.appendChild(scriptToAdd);
};
